<template>
  <div class="c-exhibition">
    <div class="c-exhibition__item" v-for="(item, index) in content" :key='index'>
      <div class="c-exhibition__item--image" :style="{backgroundImage:'url('+ item.url +')'}"></div>
      <div class="c-exhibition__item--content" :style="{backgroundColor: item.bgColor }">
        <div class="c-exhibition__item--text">
          <h3 class='title_h3' :style="{color: item.color }">{{ item.title }}</h3>
          <p :style="{color: item.contentColor }">{{ item.content }}</p>
          <q-btn outline @click="routeTo(item.link, index)" class='c-exhibition__item--btn' :label="text.more" padding="3px 2.5em" :style="{lineHeight: '1.5em', borderRadius: 0, color: item.btnColor }"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'exhibitionItems',
    props: ['content'],
    components: {
      'q-btn': Quasar.QBtn
    },
    data(){
      return{
        text: {
          more: this.$t('common.more')
        },
      }
    },
    computed: {

    },
    methods:{
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
    created(){

    }
  }
</script>

<style>


</style>
